import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/colors_and_type.css';
import './styles/global.css';
import { AuthProvider } from './app/AuthProvider';
import { App } from './app/App';
import { initTheme } from './lib/theme';

initTheme();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
